import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {LogoContainerCasino888Box} from "./logo-container.casino888.box";
import {LogoContainerDefaultBox} from "./logo-container.default.box";
import {LogoContainerCasino777Box} from "./logo-container.casino777.box";

export const LogoContainerBox = styledByTheme(LogoContainerDefaultBox)
    .forCasino888(LogoContainerCasino888Box)
    .forCasino777(LogoContainerCasino777Box).apply();
